import { GmailIcon } from "#components/ui/GmailIcon.tsx";
import { GoogleCalendarIcon } from "#components/ui/GoogleCalendarIcon.tsx";
import { GoogleDriveIcon } from "#components/ui/GoogleDriveIcon.tsx";
import { OfficevibeIcon } from "#components/ui/OfficevibeIcon.tsx";
import { WebPageIcon } from "#components/ui/WebPageIcon.tsx";
import { WorkleapFileLibraryIcon } from "#components/ui/WorkleapFileLibraryIcon.tsx";
import { WorkleapIcon } from "#components/ui/WorkleapIcon.tsx";
import { WorkleapLmsIcon } from "#components/ui/WorkleapLmsIcon.tsx";
import { WorkleapPerformanceIcon } from "#components/ui/WorkleapPerformanceIcon.tsx";
import { WorkleapSkillsIcon } from "#components/ui/WorkleapSkillsIcon.tsx";
import { INTEGRATION_MANIFESTS } from "#features/conversations/integrations/index.ts";
import { channels, googleProductChannels } from "#features/conversations/types/channels.tsx";
import { ConnectionsIcon } from "@hopper-ui/icons";
import type { ReactNode } from "react";

// Monochrome `currentColor` glyphs per channel, for the thinking steps and the citation pills.
// Native channels with no IntegrationManifest behind them (legacy connectors, the web
// crawler, and the unmapped-remote-MCP fallback) keep a hand-picked icon here. Everything
// with a manifest renders its `glyph` instead, below. A channel with no entry either way
// falls back to its CDN alt asset, which is how the MCP gateway vendors render without
// needing a React icon apiece.
const nativeSourceIcons: Record<string, ReactNode> = {
    [channels.WorkleapOfficevibe.nameKey]: <OfficevibeIcon />,
    [channels.WorkleapFileLibrary.nameKey]: <WorkleapFileLibraryIcon />,
    [channels.WorkleapLms.nameKey]: <WorkleapLmsIcon />,
    [channels.WorkleapPingboard.nameKey]: <WorkleapIcon />,
    [channels.WorkleapPlatform.nameKey]: <WorkleapIcon />,
    [channels.WorkleapSkills.nameKey]: <WorkleapSkillsIcon />,
    [channels.WorkleapPerformance.nameKey]: <WorkleapPerformanceIcon />,
    [channels.WebCrawler.nameKey]: <WebPageIcon />,
    [channels.UserRemoteMcp.nameKey]: <ConnectionsIcon size="sm" />,
    [googleProductChannels.gmail.nameKey]: <GmailIcon />,
    [googleProductChannels.drive.nameKey]: <GoogleDriveIcon />,
    [googleProductChannels.calendar.nameKey]: <GoogleCalendarIcon />
};

// Keyed by name key rather than by channel type, matching `nativeSourceIcons` above.
export const inlineSourceIcons: Record<string, ReactNode> = {
    ...nativeSourceIcons,
    ...Object.fromEntries(Object.values(INTEGRATION_MANIFESTS).map(({ nameKey, glyph: Glyph }) => [nameKey, <Glyph />]))
};
